import React from 'react';
import ReviewDetailsCard from './reviewDetails';
import { getCreateReceiptReqObj } from '../utils';
import { httpPostCall } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../common/constant';
import { useGetCollectPaymentContext } from '../context';
import { useGetStudentDetails } from './utils';

const ReviewAndReceipt = ({module}) => {
  const {studentBasicDetails} = useGetCollectPaymentContext();

  const createReceipt = async(state , ...rest) => {
    
             const reqObj = getCreateReceiptReqObj(...rest);
    
           return await httpPostCall(`${endpoint.paymentCollection.createReceipt}`, reqObj,'post',true,{state});
  }

  const studentDetails = useGetStudentDetails(studentBasicDetails);

  return (
    <>
      <ReviewDetailsCard module={module} createReceipt={createReceipt} studentDetails={studentDetails}/>
    </>
  )
}

export default ReviewAndReceipt